import runDiscountTimer from "../../js-modules/timer.js";
import videoThumbLazy from "../../js-modules/video-thumb-lazy.js";

window.addEventListener('DOMContentLoaded', () => {

    const lazyVideos = document.querySelectorAll('.video.lazy');
    videoThumbLazy(lazyVideos)

    document.querySelectorAll('.accordion .accordion__item')
        .forEach(item => item.addEventListener('click', function (e) {
            e.currentTarget.classList.toggle('active')
        }))

    const atcBox = document.getElementsByClassName('atc-box-wrapper')[0];
    const timerEls = document.querySelectorAll('.discount-timer');

    if (atcBox && timerEls.length) {
        let timerStarted = false;
        const sectionTop = atcBox.offsetTop;

        const startAllTimers = () => {
            if (timerStarted) return;
            timerStarted = true;

            timerEls.forEach(timerEl => {
                const duration = parseInt(timerEl.dataset.duration, 10) || 1800;
                runDiscountTimer(timerEl, duration);
            });

            window.removeEventListener('scroll', checkPosition);
        };

        const checkPosition = () => {
            if (window.scrollY >= sectionTop) {
                startAllTimers();
            }
        };

        checkPosition();
        window.addEventListener('scroll', checkPosition, { passive: true });
    }
})

